import React, { useEffect, useRef, useState } from "react";
import "./CardOneScreen.css";
import bookCover from "../../assets/girls_and_finances_2025.png";
import mixpanel from "../../mixpanel";

const TICKER_ITEMS = [
  {
    badge: "YouTube",
    icon: "▶",
    text: "Ներդրումային տեսաշարքն արդեն Յութուբում է",
    cta: "Դիտել",
    href: "https://youtu.be/9YK7kjrhd1s",
    bg: "linear-gradient(135deg, #b80000 0%, #e8390a 60%, #f97316 100%)",
    badgeColor: "rgba(255,255,255,0.18)",
    thumbnail: "https://img.youtube.com/vi/9YK7kjrhd1s/mqdefault.jpg",
  },
  {
    badge: "Նոր խաղ",
    icon: "🎮",
    text: "VereV — ֆինանսական խաղ ամբողջ ընտանիքի համար",
    cta: "Խաղալ",
    href: "/vereV",
    bg: "linear-gradient(135deg, #3b1fa8 0%, #6d28d9 60%, #a855f7 100%)",
    badgeColor: "rgba(255,255,255,0.18)",
    thumbnail: null,
  },
  {
    badge: "Նոր գիրք",
    icon: "📖",
    text: "2025-ից դասերը — արդեն հասանելի է",
    cta: "Կարդալ",
    href: "/girls-and-finances-wrapped-2025",
    bg: "linear-gradient(135deg, #134e2a 0%, #166534 60%, #16a34a 100%)",
    badgeColor: "rgba(255,255,255,0.18)",
    thumbnail: bookCover,
  },
];

interface CardOneScreenProps {
  onNew?: () => void;
  onResources?: () => void;
}

export default function CardOneScreen({ onNew, onResources }: CardOneScreenProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [buttonsVisible, setButtonsVisible] = useState(false);
  const [tickerIndex, setTickerIndex] = useState(0);

  useEffect(() => {
    if (ref.current) {
      requestAnimationFrame(() => ref.current!.classList.add("animate"));
      const timer = setTimeout(() => setButtonsVisible(true), 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTickerIndex((i) => (i + 1) % TICKER_ITEMS.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div ref={ref} className="card-one-screen">
      <div className="card-one-ticker">
        <div
          className="ticker-track"
          style={{ transform: `translateX(-${tickerIndex * 100}%)` }}
        >
          {TICKER_ITEMS.map((item, i) => (
            <a
              key={i}
              href={item.href}
              target={item.href.startsWith("http") ? "_blank" : undefined}
              rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
              className="ticker-item"
              style={{ background: item.bg }}
              onClick={() => mixpanel.track(`ticker_${["youtube", "verev", "book_2025"][i]}_clicked`)}
            >
              <span className="ticker-shine" />
              {item.thumbnail && (
                <span className="ticker-thumbnail-wrap">
                  <img src={item.thumbnail} alt="" className="ticker-thumbnail" />
                  <span className="ticker-thumbnail-fade" />
                </span>
              )}
              <span className="ticker-badge" style={{ background: item.badgeColor }}>
                <span className="ticker-live-dot" />
                {item.badge}
              </span>
              <span className="ticker-icon">{item.icon}</span>
              <span className="ticker-text">{item.text}</span>
              <span className="ticker-cta">{item.cta} →</span>
            </a>
          ))}
        </div>
        <span className="ticker-pips">
          {TICKER_ITEMS.map((_, i) => (
            <span key={i} className={`ticker-pip ${i === tickerIndex ? "active" : ""}`} />
          ))}
        </span>
      </div>
      <h1 className="card-one-title">Վերջապես մի բլոգ, որ տանում է Ձեզ դեպի ֆինանսական անկախություն</h1>
      <div className={`card-one-buttons ${buttonsVisible ? "visible" : ""}`}>
        <button className="cta-button" onClick={() => { mixpanel.track("main_new_user_clicked"); onNew?.(); }}>Ես նորեկ եմ այստեղ</button>
        <button className="cta-button secondary" onClick={() => { mixpanel.track("main_resources_clicked"); onResources?.(); }}>
          Ես այստեղ եղել եմ, ցանկանում եմ տեսնել ռեսուրսները
        </button>
      </div>
      <a
        href="/kids"
        className={`kids-corner-btn ${buttonsVisible ? "visible" : ""}`}
        onClick={() => mixpanel.track("main_kids_corner_clicked")}
      >
        <span className="kids-corner-sparkle">✦</span>
        երեխաների և դեռահասների համար
        <span className="kids-corner-emoji">🎒</span>
      </a>
      <a
        href="/youth"
        className={`youth-corner-btn ${buttonsVisible ? "visible" : ""}`}
        onClick={() => mixpanel.track("main_youth_corner_clicked")}
      >
        <span className="youth-corner-sparkle">✦</span>
        ուսանողների համար
        <span className="youth-corner-emoji">🎓</span>
      </a>
      <div className="gradient-overlay"></div>
    </div>
  );
}
